import React from 'react';
import clsx from 'clsx';
import CopyWrapper from 'core/components/CopyWrapper';

type Props = {
  authorizationNumber: string;
  className?: string;
};

export default function AuthorizationNumber({
  authorizationNumber,
  className,
}: Props) {
  return (
    <CopyWrapper
      text={authorizationNumber}
      tooltip="Copy authorization number"
      ariaLabel="Copy authorization number"
      className="!p-1"
    >
      <span className={clsx('truncate font-semibold', className)}>
        {authorizationNumber}
      </span>
    </CopyWrapper>
  );
}
